import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BluetoothIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bluetooth"}/>
}
